(() => {
    const elConditions = document.getElementById('product-conditions');

    // Move Product Conditions block to bottom of markup
    document.body.appendChild(elConditions);

    // Add events
    window.addEventListener('click', ev => {
        if(ev.target.matches(`.conditions-popup_toggle`)) {
            document.body.classList.toggle('__show-conditions-popup');
        }
        if(ev.target.matches(`.conditions-popup__close`)) {
            document.body.classList.remove('__show-conditions-popup');
        }
        
    });

    window.addEventListener('page:updated', () => {
        decorateLabels();
    });

    // Add description text to product options
    function decorateLabels() {
        const elOptionsText = document.querySelectorAll(`.conditions-popup__item-text[data-option]`);
        [...elOptionsText].forEach(el => {
            const elOption = document.querySelector(`.color__swatch[data-label="${el.dataset.option}"]:not(:has(.color__swatch-info))`);

            if (elOption) {
                const elSwatchInfo = document.createElement('div');
                elSwatchInfo.classList.add('color__swatch-info');
                elSwatchInfo.textContent = el.textContent;
                elOption.appendChild(elSwatchInfo);
            }
        });
    }
    decorateLabels();
})();
